import React from 'react'

const VideoInfo: React.FC = () => {
  return (
    <div className="min-h-screen bg-linear-to-br from-[#000000] via-[#0a1e29] to-[#003b4d] p-4">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-center gap-3 mb-8">
          <img
            src="https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png"
            alt="Athios Logo"
            className="w-10 h-10"
          />
          <h1 className="text-3xl font-bold text-white">Athios - Earn from Organic Posts</h1>
        </div>

        <div className="bg-black/30 backdrop-blur-xs rounded-xl p-6 border border-white/10">
          <div className="max-w-md mx-auto">
            <div className="aspect-9/16 rounded-lg overflow-hidden bg-black">
              <video
                controls
                className="w-full h-full object-contain"
                poster="https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png"
              >
                <source
                  src="https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_earn_organic_posts.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

          <div className="mt-6 text-center">
            <p className="text-white/80 text-lg mb-4">
              Discover how Athios helps athletes monetize their organic social media content
            </p>
            <p className="text-white/60 text-sm">
              Learn more about our platform and how you can start earning from your posts today.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VideoInfo
